// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__fZUZk","itemTitle":"ClientEmergencyInfo_itemTitle__17b9C","itemText":"ClientEmergencyInfo_itemText__N3VHR"};